import React from 'react';

import ClassNames from 'classnames';
import PropTypes from 'prop-types';

import './PageTitle.sass';

export const PageTitle = (props) => {
  const { text, className } = props;
  const classes = ClassNames('page-title', { [className]: !!className });

  return <div className={classes}>{text}</div>;
};

PageTitle.propTypes = {
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
};

PageTitle.defaultProps = {
  className: '',
};
